export const SPEECH_RECORDING_MAX_DURATION_MS = 2 * 60 * 1000;

export function formatSpeechRecordingElapsed(elapsedMs: number): string {
  const totalSeconds = Math.min(
    Math.floor(elapsedMs / 1000),
    Math.floor(SPEECH_RECORDING_MAX_DURATION_MS / 1000),
  );
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
